var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page", attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "colorful" }, [
          _vm._v(_vm._s(_vm.grayActive ? "GRAY" : "COLORFUL"))
        ])
      ]),
      _c(
        "el-button-group",
        [
          _c("el-button", { on: { click: _vm.grayToggle } }, [
            _vm._v("切换灰度模式")
          ]),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.graySet(true)
                }
              }
            },
            [_vm._v("打开灰度模式")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.graySet(false)
                }
              }
            },
            [_vm._v("关闭灰度模式")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = true
                }
              }
            },
            [_vm._v("模拟报错提示框")]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "错误",
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.handleDialogOpen,
            closed: _vm.handleDialogClosed
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                "line-height": "100px",
                color: "#FFF",
                "font-size": "64px",
                "font-weight": "bold",
                "border-radius": "4px",
                "background-color": "#F56C6C",
                margin: "-20px 0px"
              }
            },
            [_vm._v(" Error ")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v(" 我看到后面的内容已经变为灰度模式 ")]
              )
            ],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }